<template>
  <div v-if="file.uploadedAt" class="view-form">
    <div v-if="file.uploadedAt" class="file-info">

      <div v-if="file.dash">
        <div ref="videoContainer" class="video-container">
          <video style="max-width: 100%;" ref="videoElement" class="video-js vjs-default-skin" controls></video>
        </div>
      </div>
      <div class="file-field" v-if="file.image.length > 0"><img :src="file.image"></div>
      <div class="file-field">File: {{ file.name }}</div>
      <div class="file-field">Size: {{ file.size }}</div>
      <div class="file-field">UUID: {{ file.uuid }}</div>
      <div class="file-field">Uploaded At: {{ file.uploadedAt }}</div>
    </div>

    <div>
      <FileDownload :file-uuid="file.uuid" :internal="true"/>
    </div>
  </div>
  <div class="view-form" v-else>
    <p class="opening-text">Opening...</p>
  </div>
</template>

<script>
import FileDownload from "@/components/FileDownload.vue";
import axios from "axios";
import process from "process";
import RxPlayer from "rx-player";


export default {
  name: 'ViewFile',
  components: {FileDownload},
  data() {
    return {
      file: {
        name: '',
        size: '',
        uuid: '',
        uploadedAt: '',
        image: '',
        mimeType: '',
        dash: false,
        dashFile: ''
      },
      player: null,
    }
  },
  computed: {
    fileId() {
      return this.$route.params.fileId;
    }
  },
  methods: {
    async getFileInfo() {
      try {
        const response = await axios.post(process?.env?.VUE_APP_API_URL + '/file-info/' + this.fileId, {
          uuid: this.fileId
        });
        if (response.status !== 200) {
          console.error('Failed to get file info');
          this.$router.push('/');
          return;
        }

        this.file.uuid = this.fileId;
        this.file.name = response.data.fileName;
        this.file.image = response.data.image;
        this.file.size = this.formatBytes(response.data.fileSize);
        this.file.uploadedAt = response.data.uploadedAt;
        this.file.dash = response.data.dash;
        this.file.dashFile = response.data.dashFile

        // Determine if the file is a DASH file
        if (this.file.dash) {
          await this.setupDashPlayer();
        }

      } catch (error) {
        console.error('Failed to get file info', error);
        // this.$router.push('/');
      }
    },

    formatBytes(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1000;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    async setupDashPlayer() {
      const mpdUrl = `${process.env.VUE_APP_API_URL}/media/stream/${this.file.uuid}/${this.file.dashFile}`;

      setTimeout(() => {
        this.player = new RxPlayer({
          videoElement: this.$refs.videoElement,
        });

        this.player.loadVideo({
          url: mpdUrl,
          transport: "dash",
          autoPlay: true,
        });
      }, 2000);

    },
  },
  mounted() {
    this.getFileInfo();
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped>

.file-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.file-field {
  font-size: 16px;
  color: #333;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.file-field img {
  max-width: 100%;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.opening-text {
  animation: blink 1.5s infinite;
}
</style>